import * as React from 'react';
import { getSources } from '../util';
import { Styled } from './super-ellipse-responsive.styles';
export const SuperEllipseResponsive = ({ blur, className, profileName, src, type, ...props }) => {
    const [loaded, setLoaded] = React.useState(false);
    const imageRef = React.useRef(null);
    const { typeImg } = getSources(type);
    const imageSrc = src || typeImg;
    React.useEffect(() => {
        const img = imageRef.current;
        if (img && img.complete) {
            setLoaded(true);
        }
    }, []);
    return (React.createElement(Styled.Wrapper, { className: className },
        React.createElement(Styled.SuperEllipse, null,
            React.createElement(Styled.ImageContainer, { "$blur": loaded ? false : blur },
                React.createElement(Styled.ImageSvgBorder, { viewBox: "0 0 256 256" },
                    React.createElement("path", { className: "strokeWidth", d: "M18.947 18.947C5.627 32.267 1 61.517 1 128s4.626 95.732 17.947 109.053C32.267 250.373 61.517 255 128 255s95.732-4.626 109.053-17.947C250.373 223.733 255 194.483 255 128s-4.626-95.732-17.947-109.053C223.733 5.627 194.483 1 128 1S32.268 5.626 18.947 18.947z", fill: "transparent", stroke: "transparent", vectorEffect: "non-scaling-stroke" })),
                React.createElement(Styled.Image, { "$blur": blur, ref: imageRef, alt: profileName, "aria-label": profileName, onLoad: () => setLoaded(true), src: imageSrc, style: loaded ? {} : { display: 'none' }, title: profileName, ...props })))));
};
SuperEllipseResponsive.displayName = 'SuperEllipseResponsive';
//# sourceMappingURL=super-ellipse-responsive.js.map